import { theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

import type { StaticImageData } from 'Components/Image';
import { Typography } from 'Components/Typography';

import { moduleCloudyPill } from 'assets/content/landingPages/supplements';

const Root = styled.section<{
  img: { mobile: StaticImageData; tablet: StaticImageData; desktop: StaticImageData };
}>`
  width: 100vw;
  height: 639px;
  padding: 80px 24px;

  background-image: ${({ img }) => `url(${img.mobile.src})`};
  background-size: cover;
  background-position: bottom;
  border-bottom: 2px solid ${theme.colors.primary[400]};

  ${legacyTheme.breakpoints.up('sm')} {
    height: 801px;
    padding: 138px 72px;
    background-image: ${({ img }) => `url(${img.tablet.src})`};
    background-position: center;
  }

  ${legacyTheme.breakpoints.up('md')} {
    display: flex;
    align-items: center;

    height: 476px;
    padding-left: 135px;

    background-image: ${({ img }) => `url(${img.desktop.src})`};
  }
`;

const Content = styled.div`
  ${legacyTheme.breakpoints.up('md')} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    width: 570px;
    margin-right: auto;
  }
`;

const Title = styled(Typography)`
  margin-bottom: 16px;

  font-size: 36px;
  line-height: 1.17;
  letter-spacing: normal;

  ${legacyTheme.breakpoints.up('sm')} {
    margin-bottom: 32px;
    font-size: 60px;
    letter-spacing: normal;
  }

  ${legacyTheme.breakpoints.up('md')} {
    margin-bottom: 24px;
  }
`;

const Paragraph = styled(Typography)`
  line-height: 1.5;
  letter-spacing: 0.25px;

  ${legacyTheme.breakpoints.up('md')} {
    max-width: 550px;
  }
`;

export const ModuleCloudyPill = () => (
  <Root data-testid="supplements-landing-module" img={moduleCloudyPill.image}>
    <Content>
      <Title markupName="p" variant="p1">
        {moduleCloudyPill.title}
      </Title>
      <Paragraph markupName="p" variant="p1">
        {moduleCloudyPill.paragraph}
      </Paragraph>
    </Content>
  </Root>
);
